var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumber4Xl = function SvgNumber4Xl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 245.52 345.93"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.92,274.77h-25.92v58.56c0,9.12-1.44,9.6-9.6,9.6h-51.84c-9.12,0-10.08-.96-10.08-9.12v-59.04H13.08c-8.16,0-10.08-1.92-10.08-10.08v-56.64L125.4,9.33c4.32-7.2,4.8-7.68,12.48-4.32l47.52,19.68c9.12,3.84,9.12,6.24,4.32,13.44l-118.08,176.16h65.28l8.64-68.64c.96-8.16,1.44-9.6,9.6-9.6h42.24c8.16,0,9.6,1.92,9.6,10.08v69.12h25.92c9.12,0,9.6.96,9.6,12v37.44c0,8.16-.48,10.08-9.6,10.08Z"
  })));
};
export { SvgNumber4Xl as ReactComponent };